const lowerCaseSensitiveFields = [
  'answers',
  'password',
  'token',
  'email',
  'givenname',
  'familyname',
  'phonenumber',
  'healthcaresystemlookupid',
  'healthcaresystempatientid',
  'createdby',
  'clinicianemail',
  'pisystemid',
  'postalcode',
];

function scrubSensitiveData<T extends object>(obj: T, seen = new WeakSet<object>()): T {
  if (seen.has(obj)) {
    return obj;
  }
  seen.add(obj);

  const scrubbed = obj;

  for (const key in scrubbed) {
    const keyProp = scrubbed[key];
    if (lowerCaseSensitiveFields.some((field) => key.toLowerCase().includes(field))) {
      scrubbed[key] = '[Filtered SDK side]' as T[Extract<keyof T, string>];
    } else if (typeof keyProp === 'object' && keyProp !== null && !Array.isArray(keyProp)) {
      scrubbed[key] = scrubSensitiveData(keyProp, seen);
    } else if (Array.isArray(keyProp)) {
      scrubbed[key] = keyProp.map((item) =>
        typeof item === 'object' && item !== null ? scrubSensitiveData(item, seen) : item
      ) as T[Extract<keyof T, string>];
    }
  }

  return scrubbed;
}

export { scrubSensitiveData };
